import { render, staticRenderFns } from "./Assinaturas.vue?vue&type=template&id=5bdb1bae&scoped=true&"
import script from "./Assinaturas.vue?vue&type=script&lang=js&"
export * from "./Assinaturas.vue?vue&type=script&lang=js&"
import style0 from "./Assinaturas.vue?vue&type=style&index=0&id=5bdb1bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb1bae",
  null
  
)

export default component.exports